import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";

export const useListaProcesuProjektu = (id, enabled = true) => {

    return useQuery({
        queryKey: [`lista_procesow_element__${id}`],
        queryFn: () => getList(`/oper/${MAIN_REJESTR_API_SHORT}/proces/${id}`),
        enabled: enabled
    })
}